export const APP_NAME = 'nav-website'
export const DESIGN_ASSETS_URL = 'https://design-assets.nav.com'
export const pagesCollection = 'pages'

export const CMS_ASSETS_BASE_URL = 'https://nav-cms-assets.nav.com'
export const PLACEHOLDER_IMAGE_URL = `${CMS_ASSETS_BASE_URL}/static/images/placeholder.jpg`
